import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "transformpositionreference"
    }}>{`TransformPositionReference`}</h1>
    <p>{`Options for specifying the reference position for X and Y attributes of style. If set none, it will disable the attribute.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PAGE_EDGE_REFERENCE`}</strong>{` = 1348945255`}</p>
      <p parentName="blockquote">{`Corresponding edge of the page. Left edge for X attribute, Top edge for Y attribute.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PAGE_MARGIN_REFERENCE`}</strong>{` = 1883721063`}</p>
      <p parentName="blockquote">{`Corresponding page margin of the page.  Left margin for X attribute, Top margin for Y attribute.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      